<template>
	<div class="ma-0 pa-0 oper-group-table-root pb-1">
		<v-data-table
			:headers="headers"						
			fixed-header
			:items="operGroups"		   
			class="elevation-1 oper-group-table"
			disable-pagination
			hide-default-footer
			height="100%"
			width="100%"
			item-key="operGroupId"
			v-model="selectedOperGroup"
			>
			<template v-slot:item.operGroupId="{ item }">
				<v-container  class="pa-0">
				<v-row class="pa-0">

					<v-col class="pa-0 mx-0">
						<v-icon v-if="item.selectState==1" v-on:click.stop.prevent="doUnSelectOperGroup(item)">mdi-checkbox-marked</v-icon>
						<v-icon v-else v-on:click.stop.prevent="doSelectOperGroup(item)">mdi-checkbox-blank-outline</v-icon>						
					</v-col >
						
					<v-col class="pa-0">
						<template v-for="n in 2" >
							<span :key="n"/>&#12288;
						</template>
					</v-col>
						
					<v-col class="pa-0 code-item">
						{{ item.operGroupId}}
					</v-col>					
				</v-row>
				</v-container>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {default as OperGroupApi} from "../../../../api/smp/sys/OperGroupApi.js";
	import {default as AuthManageApi} from "../../../../api/smp/sys/AuthManageApi.js";
	
	export default {
		name: 'OperGroupAuthTable', 
		components: {
		},
		data: () => ({
			headers:[				
				{text: '编号',align: 'start',sortable: false,value: 'operGroupId',width:150,divider:true},
				{ text: '名称', value: 'operGroupName',sortable: false ,width:600,divider:true},				
				{ text: '状态', value: 'statusName',sortable: false ,width:100,divider:true},
                { text: '', value: '',sortable: false ,divider:false},
			],
			operGroups:[],
			selectedOperGroup:[],
			editing:false
			}),
		methods:{
			setEditing(editState){
				this.editing = editState;
			},
			doSelectOperGroup(group){
				if(!this.editing)
					return;
				group.selectState =1;
			},
			doUnSelectOperGroup(group){
				if(!this.editing)
					return;
				group.selectState = -1;
			},
			getSelectedOperGroups(){
				let me = this;
				let selected = [];
				this.operGroups.forEach(function(item){
					if(item.selectState==1)
						selected.push(item);
				});
				return selected;
			},
			
			async loadOperGroups(){
				let me = this;
				let resp = await OperGroupApi.queryAllOperGroup();
				
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取操作员组信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let operGroups = data.data.operGroups;
				//修改类型名
				operGroups.forEach(function(group){
					if(group.status==1)
					  group.statusName="有效";
					else
					  group.statusName="其他";	
					group.selectState = -1;
				});
				me.operGroups = operGroups;
			
			},
			
			async loadOperBelongOperGroupPriviledge(operId){
				let me = this;
				
				let resp = await AuthManageApi.queryOperBelongOperGroupPriviledge(operId);
			
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取操作员所属组权限信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let groups = data.data.groups;					
				groups.forEach(function(item){
					me.operGroups.forEach(function(group){
						if(item.operGroupId==group.operGroupId)
						  group.selectState=1;
					});
					
				});
				
			},
			
			
		},
		computed:{
			
		}
	}
</script>

<style scoped>
	.oper-group-table-root{
		
	}
	.oper-group-table{
		height:100%;
	}
	.code-item{
		flex-grow: 100;
	}
</style>
